<template>
    <mdb-container class="infosticky">
        <mdb-card class="profile-card" testimonial v-if="userid">

            <!--Avatar-->
            <mdb-card-avatar class="mx-auto">
                <img v-if="user.profilepicture" :src="user.profilepicture" class="rounded-circle" onerror="this.src='https://www.pngkey.com/png/full/115-1150152_default-profile-picture-avatar-png-green.png'"/>
                <img v-else src="https://www.pngkey.com/png/full/115-1150152_default-profile-picture-avatar-png-green.png" class="rounded-circle"/>

            </mdb-card-avatar>

            <mdb-card-body class="pt-0 mt-0">
                <!--Name-->
                <mdb-card-title>
                <div class="text-center">
                    {{user.fullname}}
                    <h6 class="font-weight-bold blue-text mb-4" v-if="user.title">{{user.title}}</h6>
                </div>
                </mdb-card-title>

                <ul class="striped list-unstyled">
                    <li><strong>Agence:</strong> {{user.agency}}</li>

                    <li><strong>Courriel:</strong> {{user.email}}</li>

                    <li><strong>Adresse:</strong> {{user.address}}</li>

                    <li><strong>Ville:</strong> {{user.city}}</li>

                    <li><strong>Ajouté le:</strong> {{user.added_at}}</li>

                    <li v-if="user.islinked"><strong class="green-text">Profil détecté dans notre portail</strong></li>
                    <li v-else><strong class="red-text">Impossible de lier cet utilisateur à notre portail</strong></li>
                </ul>

            </mdb-card-body>
        </mdb-card>
    </mdb-container>
</template>
<script>
    import {
        mdbCard,
        mdbCardBody,
        mdbContainer,
        mdbCardAvatar,
        mdbCardTitle,
    } from 'mdbvue';
    import Apicall from '../libs/Apicall';

    export default {
        name: 'usercard',
        components: {
            mdbCard,
            mdbCardBody,
            mdbContainer,
            mdbCardAvatar,
            mdbCardTitle,
        },
        props: {
            type: String,
            userid: String,
        },
        data() {
            return {
                nb: 0,
                user: {},
            };
        },
        watch: {
            userid: {
                immediate: true,
                handler(val, oldval) {
                    if (val !== oldval && val !== null) {
                        this.getAndDisplayUser();
                    }
                },
            },
        },
        methods: {
            getAndDisplayUser() {
                const api = new Apicall();
                const self = this;
                if (this.type === 'preregister') {
                    api.getPreregisterUserInfo(this.userid).then((response) => {
                        if (response.status === 'OK') {
                            self.user = response.user;
                        }
                    });
                }
            },
        },
    };
</script>
<style scoped>
    .profile-card {
        margin-top: 100px;
    }

    .profile-card .avatar {
        max-width: 150px;
        max-height: 150px;
        margin: -70px auto 0;
        -webkit-border-radius: 50%;
        border-radius: 50%;
        overflow: hidden;
    }

    .slide-toggle-enter-active {
        transition: 0.3s ease-in;
        opacity: 1;
        max-height: 500px;
    }
    .slide-toggle-enter,
    .slide-toggle-leave-active {
        opacity: 0;
        max-height: 0;
    }
    .slide-toggle-leave {
        opacity: 1;
        max-height: 500px;
    }
    @media only screen and (min-width: 1200px)  {
        .infosticky{
            position:fixed;top:150px;width: 25.3%;
        }
    }
</style>
